import Handler from '@/core/domain/usecase/handler';

const createEquipmentHistoryRepository = (axios) => async (data) => {
  try {
    const response = await axios.post(`/equipment-history`,
      data
    )
    return response.data
  } catch (err) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createEquipmentHistoryRepository